import 'slick-carousel';
import slickCss from 'slick-carousel/slick/slick.css';

class TextWithImageCarousel {
  constructor($main) {
    if (!this.initDomElements($main)) {
      return false;
    }

    this.initCarousel();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.items = this.domElements.main.find(
        '.text-with-image-carousel__items');
    this.domElements.navigation = this.domElements.main.find(
        '.text-with-image-carousel__control');
    return true;
  }

  initCarousel() {
    const slickConfig = {
      dots: true,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      fade: false,
      autoplay: false,
      adaptiveHeight: true,
      appendArrows: this.domElements.navigation,
      appendDots: this.domElements.navigation
    };

    this.domElements.items.slick(slickConfig);
  }
}

export default TextWithImageCarousel;
